import React, { useState, useEffect } from 'react'

import expandLogo from '../../assets/images/Expand Arrow1.png';

import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { createOrUpdateShareForAGameType, getSharePercentByGameTypeService } from '../../services/sharepercent.service';
import useUserData from '../../hooks/useUserData';

const SharePercent = (props) => {

    let { showEdit, setShowEdit, inputModal, setInputModal, handleSubmitModal ,errors } = props;

    const [sharePercent, setSharePercent] = useState([]);
    const [expand, setExpand] = useState(false);
    const [userData, setUserData] = useUserData();
    const [follow, setFollow] = useState({ userId: '', name: 'User Name' });
    let [adminPercent, setAdminPercent] = useState(0);
    const [err, setErr] = useState(false)
    
    const  dispatch = useDispatch();

    const selectUser= ( e ) => {
        e.stopPropagation();
        setExpand(!expand);
    }

    const handleClose = () => {
        setShowEdit(false);
        setExpand(false);
    }

    const handleAdd = () => {
        setSharePercent([...sharePercent, { userId: follow.userId, name: follow.name, percent: 0, status: true }]);
        setFollow({ userId: '', name: 'User Name' });
    }

    const getSharePercentData = async (signal) => {
        dispatch(setIsLoading(true))

        try {
            const result = await getSharePercentByGameTypeService(signal, inputModal.gameTypeId);
            if(result.data) {
                let data = result.data.map(el => {
                    return {...el,  status: true}
                })
                setSharePercent(data)
            }
        }
        catch (error) {
        dispatch(
            setToastMessage({
            message: error?.response?.data?.message || error?.message,
            type: "error",
            })
        );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    const createOrUpdateShare = async () => {
        if(err) return;
        dispatch(setIsLoading(true))
  
        try {
            let payload = sharePercent.map(({ sharePercentId, name, ...rest }) => rest)
            const result = await  createOrUpdateShareForAGameType(payload, inputModal.gameTypeId);
            if(result.data) {
                dispatch(
                    setToastMessage({
                    message: result?.data?.message || "SUCCESS",
                    type: "success",
                    })
                );
               
            }
        }
        catch (error) {
        dispatch(
            setToastMessage({
            message: error?.response?.data?.message || error?.message,
            type: "error",
            })
        );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        getSharePercentData(signal);

        return () => {
            controller.abort();
        }
    },[inputModal]);

   
    const handleChange = (index, e) => {
       
        setSharePercent( [...sharePercent], sharePercent[index].percent = parseInt(e.target.value));
      
        const totalPercentExcludingAdmin = sharePercent
        .filter(user => user.name !== 'admin' && user.status != false) // Filter out admin
        .reduce((acc, user) => acc + user.percent, 0); // Sum the percent
       
        setErr(false)
        if( totalPercentExcludingAdmin > 100) setErr(true);
        setAdminPercent(100 - totalPercentExcludingAdmin)
        
        setSharePercent(prev => {
            let result = prev.map(user => {
                      if (user.name === 'admin') {
                        return { ...user, percent: 100 - totalPercentExcludingAdmin }; // Subtract from 100
                      }
                      return user;
                    });
            return result
        }) 
    };

    const removeShare = (userId) => {
       
        // setSharePercent(prev => prev.filter(el => el.userId !== userId ))
       
         
       setSharePercent(prev => {
     
        let result = prev.map(user => {
                  
                     if( user.userId === userId) {
                        return {...user, status: false}
                     }
                     return user;
                   });
           
           return result
       }) 

       setSharePercent(prev => {
     
        const totalPercentExcludingAdmin = prev
        .filter(user => user.name !== 'admin' && user.status !== false) // Filter out admin
        .reduce((acc, user) => acc + user.percent, 0); // Sum the percent
         console.log(totalPercentExcludingAdmin, "user total");
         
        let result = prev.map(user => {
                     if (user.name === 'admin') {
                       return { ...user, percent: 100 - totalPercentExcludingAdmin }; // Subtract from 100
                     }

                     return user;
                   });
           console.log(result);
           
           return result
       }) 

    }


    // useEffect(() => {
    //     const updatedUsers = sharePercent.map(user => {
    //       if (user.name === 'admin') {
    //         return { ...user, percent: user.percent - totalPercentExcludingAdmin }; // Subtract from 100
    //       }
    //       return user;
    //     });
    //     setSharePercent(updatedUsers);
    //   }, [totalPercentExcludingAdmin]);

    const userShareList = (sharePercent && sharePercent.map((user, index) => {
        return (
         <>
         {
            user.status &&  <tr index={user.userId} className='w-full'>
            <th className='text-userText text-left w-10 p-4'>{index + 1}</th>
            <th className='text-userText text-left w-[40%] p-4'>{user.name}</th>
            <th className='text-userText p-4'>
                <input 
                    type="number" 
                    value={user.percent} 
                    onChange={(e) => handleChange(index, e)} 
                    className='bg-slate-100 rounded-sm outline-none px-2 py-2 mr-2 w-24 text-right' 
                />%
            </th>
            <th>
                    {user.name !== "admin" &&    
                     <button onClick={()=>removeShare(user.userId)}>
                        remove
                    </button>}
            </th>
        </tr>
         }</>
            )
        }))

    return (
        
        <>
            {showEdit && (
                <div className="fixed inset-0 bg-textcol bg-opacity-30 backdrop-blur-sm flex justify-center items-center">
                    <div className="flex justify-center items-center w-[80%] h-[80%] bg-gray-500 rounded-sm">
                        <div className='w-[69%] h-[85%] bg-white'>
                           
                            <div className="w-[60%] h-[85%] overflow-y-auto my-10 ml-10">
                              {err && <div className='text-rose-600 w-full mx-6'> Total Percent cannot exceed 100 % </div>}
                        
                                {userShareList}
                            </div>
                            
                        </div>
                        <div className='flex flex-col justify-around w-[32%] h-[85%] bg-white'>
                            
                        <div className='flex flex-col items-end gap-5 mt-4 mx-10'>
                            <div className='flex items-center justify-between bg-bgColor text-fgColor py-1 ps-4 w-[200px] cursor-pointer font-semibold rounded-sm relative'
                                onClick={(e)=>selectUser(e)}>
                                <div>{follow.name}</div>
                                <img src={expandLogo} alt="Expand-logo" className='' />
                                {
                                    expand ?
                                        <div className="bg-bgColor text-fgColor w-[200px] absolute top-[39px] left-0 cursor-pointer overflow-auto h-[200px] z-40">
                                            {
                                                userData && userData.map((user) => (
                                                    <div key={user.userId}
                                                        className={`${user.userId != user.length ? "border-b-2 " : "border-b-0"} py-2 px-4 hover:bg-primary hover:text-rectangle transition-all duration-100 `}
                    
                                                        onClick={() => setFollow({ userId: user.userId, name: user.name })}
                                                    >
                                                        {user.name}
                                                    </div>
                                                ))
                                            }
                                        </div> : ""
                                    }
                                </div>

                                <button 
                                    type='button' 
                                    onClick={handleAdd}
                                    className='px-7 py-2 text-white bg-primary rounded-md cursor-pointer'>
                                        Add
                                </button>
                            </div>

                            {/* {
                                !!adminPercent && <div className='flex flex-col justify-center items-center w-full h-[30%]'>
                                <div className={`flex justify-center items-center w-24 h-24 rounded-full text-white text-2xl font-bold ${adminPercent > 100 ? 'bg-red' : 'bg-primary' }`}>
                                    {adminPercent}% 

                                </div>
                                    { adminPercent < 0 && <p className='text-red font-semibold mt-5'>{adminPercent }% need to adjust !!!</p>}
                                    {adminPercent > 0 && <p className='text-green font-semibold mt-5'>{ adminPercent}% will auto combine to Admin !!!</p>}
                            </div>
                            } */}
                            
                            <div className="flex justify-end items-center w-[80%] h-[35px] mt-5 select-none">
                                <button className="px-7 py-2 mr-2 text-white bg-primary rounded-md cursor-pointer" onClick={createOrUpdateShare}
                                >Save</button>
                                <button className="px-7 py-2 mr-2 text-white bg-primary rounded-md cursor-pointer" onClick={handleClose}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default SharePercent